import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/shadcn/card.tsx";
import React from "react";
import { Button } from "@/components/shadcn/button.tsx";

const cp = (window as any).cp;

export const SubscriptionCloudPayments = () => {
  const launchWidget = () => {
    const intentParams = {
      publicTerminalId: "pk_c7daf8c50f108566e6cd9e1b7db6e", // идентификатор терминала
      currency: "RUB",
      paymentSchema: "Single",
      amount: 590,
      skin: "classic",
      culture: "ru-RU",
      description: 'План "Опти" для аккаунта oleg.egorovich@gmail.com на месяц',
      paymentUrl: "https://chatbot.most-ai.com/account",
      receiptEmail: "oleg.egorovich@gmail.com",
      tokenize: false,
      restrictedPaymentMethods: [],
      metadata: {
        JsonData: {
          userId: 4287634,
          discountPerc: 0,
          plan: "opti",
          admitadUid: null,
          cityadsUid: null,
          proPlanPrice: 0,
          CloudPayments: {
            CustomerReceipt: {
              Items: [
                {
                  label: "План:",
                  price: 590,
                  quantity: 1,
                  amount: 590,
                  vat: 5,
                },
              ],
              email: "oleg.egorovich@gmail.com",
              amounts: {
                electronic: 590,
              },
            },
          },
        },
      },
      userInfo: {
        accountId: "4287634",
      },
      emailBehavior: "Optional",
      type: "Default",
      scenario: "Widget",
      retryPayment: true,
      cryptogramMode: false,
    };

    const widget = new cp.CloudPayments();
    widget
      .start(intentParams)
      .then(function (widgetResult) {
        console.log("result", widgetResult);
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  return (
    <Card className="">
      <CardHeader className="relative">
        <CardTitle>Тарифы и подписка</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <Button onClick={launchWidget}>PAY</Button>
      </CardContent>
      <CardFooter className="flex justify-between"></CardFooter>
    </Card>
  );
};
